<template>
	<div class="echarts-container">
		<!-- 图表容器，必须设置宽高 -->
		<div ref="chart" class="chart-box"></div>
	</div>
</template>

<script>
	import mixin from '@/utils/mixin';
	export default {
		mixins: [mixin],
		props: ['propChartKey'],
		data() {
			return {
				chart: null // 存储图表实例
			}
		},
		mounted() {
			if (!this.propChartKey) return;
			request({
				url: '/api/chart/selectChart',
				data: {
					key: this.propChartKey,
					params: this.propParams || [],
				},
				success: resp => {
					// 初始化图表（需在DOM加载完成后执行）
					this.initChart(resp.data)
					// 监听窗口大小变化，重绘图表
					window.addEventListener('resize', this.handleResize)
				}
			})
		},
		methods: {
			initChart({
				labelField,
				valueField,
				options,
				list
			}) {


				// 1. 获取DOM元素并初始化图表实例
				this.chart = echarts.init(this.$refs.chart)

				// 2. 定义图表配置项
				const option = {

					...options
				}

				const labelData = [];
				const valueData = [];

				list.forEach(item => {
					let label = item[labelField];
					let value = item[valueField];
					if (labelData.includes(label)) {
						return;
					}
					labelData.push(label);
					valueData.push(value);
				})

				option.xAxis.data = labelData;
				option.series[0].data = valueData;

				// 3. 设置配置项并渲染图表
				this.chart.setOption({
					...option
				})
			},
			handleResize() {
				// 窗口大小变化时重绘图表
				if (this.chart) {
					this.chart.resize()
				}
			}
		},
		beforeDestroy() {
			// 组件销毁时，销毁图表实例释放内存
			if (this.chart) {
				this.chart.dispose()
			}
			// 移除事件监听
			window.removeEventListener('resize', this.handleResize)
		},
	}
</script>

<style scoped>
	.echarts-container {
		width: 100%;
		padding: 20px;
	}

	.chart-box {
		width: 100%;
		height: 500px;
		/* 必须设置高度，否则图表不显示 */
	}
</style>